import tokens from '@/styles/tokens';

export const SCREEN_XS = parseInt(tokens.screenxs, 10);
export const SCREEN_SM = parseInt(tokens.screensm, 10);
export const SCREEN_MD = parseInt(tokens.screenmd, 10);
export const SCREEN_LG = parseInt(tokens.screenlg, 10);
export const SCREEN_ML = parseInt(tokens.screenml, 10);
export const SCREEN_XLG = parseInt(tokens.screenxlg, 10);
export const SCREEN_XXLG = parseInt(tokens.screenxxlg, 10);
export const SCREEN_XXXLG = parseInt(tokens.screenxxxlg, 10);
